import React from "react";
import { Header } from "../ui/header";
import { Footer } from "../ui/footer";
import Scrolltotop from "../ui/scrolltotop";

export const Default = ({ children }) => {
  return (
    <>
      <Scrolltotop />
      <Header />
      <div className="main">{children}</div>
      <Footer />
    </>
  );
};
